<template>
  <b-modal
    id="sort-comment-setting"
    size="lg"
    hide-header
    centered
    no-close-on-backdrop
    @show="initSortValue"
  >
    <template #default>
      <div id="sort-comment-setting-group" :class="isMobile ? 'mobile-mode' : 'pc-mode'">
        <b-form-group label-size="lg" label-class="font-weight-bold">
          <template #label>
            <div class="d-flex flex-directions-row">
              <div>{{ SORT_COMMENT_SETTING_TITLE }}</div>
            </div>
          </template>
          <div class="setting-description">
            {{ SORT_COMMENT_DESCRIPTION }}
          </div>
          <b-form-radio-group v-model="sortValue" stacked>
            <!-- 昇順 -->
            <b-form-radio value="ASC">{{ ASC_LABEL }}</b-form-radio>
            <!-- 降順 -->
            <b-form-radio value="DESC">{{ DESC_LABEL }}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </template>
    <template #modal-footer="{ close }">
      <b-row class="w-100" align-h="around" no-gutters>
        <cancel class="col-5" label="キャンセル" v-on:cancel="close" />
        <confirm class="col-5" label="保存" v-on:confirm="saveSortValue(close)" />
      </b-row>
    </template>
  </b-modal>
</template>

<style lang="scss" scoped>
.setting-description {
  white-space: pre-line;
  padding-bottom: 16px;
  &.pc-mode {
    padding: 16px 0;
  }
}

#sort-comment-setting {
  #sort-comment-setting-group {
    &.pc-mode {
      padding: 1rem;
      background-color: whitesmoke !important;
    }
    &.mobile-mode {
      min-height: 75vh;
    }
  }
}
</style>

<script lang="ts">
import Cancel from "@/components/button/Cancel.vue";
import { useAppStore } from "@/store";
import Confirm from "@/components/button/Confirm.vue";
import { computed, defineComponent, ref, watch, type PropType } from "vue";
import type { SORT_TYPE } from "@/store";

export default defineComponent({
  name: "sort-comment-setting",
  components: {
    Cancel,
    Confirm,
  },
  props: {
    originSortValue: { type: String as PropType<SORT_TYPE>, default: () => "ASC" },
  },
  setup(props) {
    const SORT_COMMENT_SETTING_TITLE = "コメントの並び順設定";
    const SORT_COMMENT_DESCRIPTION =
      "組織内のコメントの並び順の初期値の指定を行えます。\n各投稿内でコメントの並び順の変更を一時的に行えますが、話題を移動すると初期値に戻ります。";
    const ASC_LABEL = "昇順";
    const DESC_LABEL = "降順";

    const sortValue = ref<SORT_TYPE>("ASC");

    watch(
      () => props.originSortValue,
      (): void => {
        sortValue.value = props.originSortValue;
      }
    );

    const isMobile = computed((): boolean => {
      return useAppStore().isMobile;
    });

    // storeのsortに合わせる
    const initSortValue = (): void => {
      sortValue.value = props.originSortValue;
    };

    // sortValueの保存
    const saveSortValue = async (close: () => void): Promise<void> => {
      const domainId = useAppStore().domainId;
      await useAppStore().setSortCommentSetting({ domainId: domainId, sort: sortValue.value });
      close();
    };

    return {
      SORT_COMMENT_SETTING_TITLE,
      SORT_COMMENT_DESCRIPTION,
      ASC_LABEL,
      DESC_LABEL,
      sortValue,
      isMobile,
      initSortValue,
      saveSortValue,
    };
  },
});
</script>
